import React,{useRef} from "react"
import { Dropdown, InputDefault } from "../../../../components/ui"
import { useFormik } from 'formik';
import { RewardSchema } from "../../../../modules/helperValidation";



interface Props {
    handleChange: (e: any) => void
    id? : string
    initLoad? : any
    loadings? : any
}

const FormRewards : React.FC <Props> = ({handleChange, id, initLoad, loadings}) => {
    const resetForms = useRef<any>(null)

    const TypeMaster = [
      { label: 'Digital', value: 'digital' },
    ]
    const initValue = {
      rewards: '',
      description: '',
      type: '',
      qty: 0,
      point: '',
      image: '',
  }
    const formik = useFormik({
        initialValues :id ? initLoad : initValue,
        onSubmit: (values, {resetForm}) => {
           handleChange(values)
        },
        enableReinitialize: true,
        validationSchema: RewardSchema
    })

    return(
        <form onSubmit={formik.handleSubmit} ref={resetForms}>
            <div className='d-flex flex-column align-items-center gap-4'>
                <div className='mb-3 w-100'>
                  <label htmlFor='rewards' className='form-label'>
                   Rewards
                  </label>
                  <InputDefault type='text' id='rewards' name="rewards" onChange={formik.handleChange} value={formik.values.rewards}  validation={formik.errors.rewards && formik.touched.rewards }  textError={formik.errors.rewards}    />
                  {/* <label htmlFor='rewards' className='form-label'>
                   Code
                  </label>
                  <InputDefault type='text' id='code' name="code" onChange={formik.handleChange} value={formik.values.code} validation={formik.errors.code && formik.touched.code }  textError={formik.errors.code}  /> */}
                  <label htmlFor='description' className='form-label'>
                    Description
                  </label>
                  <InputDefault type='text' id='description'  name="description" onChange={formik.handleChange} value={formik.values.description} validation={formik.errors.description && formik.touched.description }  textError={formik.errors.description}  />
                  <label htmlFor='type' className='form-label'>
                    Type
                  </label>
                  <Dropdown  id={'type'} data={TypeMaster} onChanges={formik.handleChange} value={formik.values.type}  validation={formik.errors.type && formik.touched.type }  textError={formik.errors.type}  />
                  <label htmlFor='qty' className='form-label'>
                    Qty
                  </label>
                  <InputDefault disabled  type='number' id='qty' onChange={formik.handleChange} value={formik.values.qty}  validation={formik.errors.qty && formik.touched.qty }  textError={formik.errors.qty}   />
                  <label htmlFor='point' className='form-label'>
                    Point Deduction
                  </label>
                  <InputDefault type='number' id='point'  onChange={formik.handleChange} value={formik.values.point}  validation={formik.errors.point && formik.touched.point }  textError={formik.errors.point} />
                  {id ? null :  <>
                    <label htmlFor='image' className='form-label'>
                      Image
                    </label>
                    <InputDefault  type='file' id='image' onChange={(e) => formik.setFieldValue('image', e.target.files![0])}   />
                  </> }
                  <div className='card-footer d-flex justify-content-end py-6 px-9'>
                  {!loadings ?  <button
                     className='btn btn-primary'
                     data-bs-target='#add-edit-member'
                     type="submit"
                   >
                      Submit
                  </button> :  <button
                     className='btn btn-primary'
                     data-kt-indicator="on"
                     type="button"
                   >
                     <span className="indicator-progress">Please wait... 
                     <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button> }
                 </div>
                </div>
            </div>
        </form>
    )
}

export default FormRewards